import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getMarcas = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/marcas/getMarcas`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getMarcasNombres = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/marcas/getMarcasNombres`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateEstadoMarca = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/marcas/updateEstadoMarca`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const validateAsignacionEliminar = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/marcas/validateAsignacionEliminar`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const deleteMarca = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/marcas/deleteMarca`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateMarca = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/marcas/updateMarca`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveMarca = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/marcas/saveMarca`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveImagen = ({file, idMarca, nombreImg, extension}) => {
    const formData = new FormData();

    formData.append('id', idMarca.toString());
    formData.append('extension', extension);
    formData.append('nombreImg', nombreImg);
    formData.append('img', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/marcas/saveImagen`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const marcasService = {
    getMarcas,
    getMarcasNombres,
    updateEstadoMarca,
    validateAsignacionEliminar,
    deleteMarca,
    updateMarca,
    saveMarca,
    saveImagen
};